import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { automationsClient } from '#pplx_generated/typespec/rest/automations/client.js';
const PROJECT_AUTOMATIONS_PATH = '/rest/automations/projects/{collection_uuid}';
const PROJECT_AUTOMATIONS_PAGE_SIZE = 100;
export function getProjectAutomationsQueryKeyPrefix() {
    return QueryClientHelper.makeQueryKey(PROJECT_AUTOMATIONS_PATH);
}
export function getProjectAutomationsQueryKey(collectionUuid) {
    return QueryClientHelper.makeQueryKey(PROJECT_AUTOMATIONS_PATH, collectionUuid);
}
export async function fetchProjectAutomations(collectionUuid) {
    const automations = [];
    const seenCursors = new Set();
    let cursor;
    do {
        const { data, error, response } = await automationsClient.GET(PROJECT_AUTOMATIONS_PATH, 'list-project-automations', {
            params: {
                path: { collection_uuid: collectionUuid },
                query: { limit: PROJECT_AUTOMATIONS_PAGE_SIZE, cursor },
            },
            timeoutMs: getQueryTimeoutMs(),
            numRetries: 1,
        });
        if (error || data == null) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to list Project automations',
                cause: error ?? new Error('Project automations API returned no data'),
                status: response.status ?? 0,
            });
        }
        automations.push(...data.automations);
        cursor = data.next_cursor ?? undefined;
        if (cursor != null) {
            if (seenCursors.has(cursor)) {
                throw new Error('Project automations API returned a repeated cursor');
            }
            seenCursors.add(cursor);
        }
    } while (cursor != null);
    return automations;
}
export function useProjectAutomations(collectionUuid, { enabled = true } = {}) {
    return useQuery({
        queryKey: getProjectAutomationsQueryKey(collectionUuid),
        queryFn: () => fetchProjectAutomations(collectionUuid),
        enabled: enabled && collectionUuid.length > 0,
    });
}
//# sourceMappingURL=useProjectAutomations.js.map